import { useState, useCallback } from 'react';
import { useUser } from '../src/context/UserContext'; // Adjust the import path as needed

/**
 * Custom hook to handle login modal state and functionality
 *
 * @param {Object} options - Hook options
 * @param {function} options.onAuthenticatedAction - Function to call if user is already authenticated
 * @returns {Object} Object containing modal state and functions
 */
const useLoginModal = ({ onAuthenticatedAction } = {}) => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [loginModalProps, setLoginModalProps] = useState({
    actionText: 'to continue',
    entityName: '',
  });
  const { user } = useUser();

  /**
   * Check if user is logged in, if yes perform the action,
   * if not show the login modal
   */
  const requireLogin = useCallback(
    (props = {}) => {
      if (user) {
        // User is already logged in, perform the action
        if (onAuthenticatedAction && typeof onAuthenticatedAction === 'function') {
          onAuthenticatedAction();
        }
        return true;
      } else {
        // User is not logged in, show the login modal with custom props
        setLoginModalProps({
          actionText: props.actionText || 'to continue',
          entityName: props.entityName || '',
          returnPath: props.returnPath || window.location.pathname,
        });
        setIsLoginModalOpen(true);
        return false;
      }
    },
    [user, onAuthenticatedAction],
  );

  // Close the login modal
  const closeLoginModal = useCallback(() => {
    setIsLoginModalOpen(false);
  }, []);

  return {
    isLoginModalOpen,
    loginModalProps,
    requireLogin,
    closeLoginModal,
  };
};

export default useLoginModal;
